var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isUserLoggedIn)?_c('div',[_c('ObjectsAutocomplete',{attrs:{"disabled":_vm.$store.state.hidden}}),(_vm.$store.state.hidden)?_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('message.social_disabled'))+" ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }